<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style lang="less">
@import './assets/style/global.less';
/* @import './utils/baseProto.js'; */

body {
  background-color: #fff;
}
</style>
